<p>member-info-service-test works!</p>
